import React, { useState, useEffect } from 'react';
import { Card, Table, Tag, Typography, Button, Space, Select, Form, DatePicker, Modal, Input, message, Descriptions, Drawer, Steps, Row, Spin, Divider, Tooltip } from 'antd';
import { SearchOutlined, ReloadOutlined, RedoOutlined, CloudUploadOutlined, LoadingOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const { RangePicker } = DatePicker;
const { TextArea } = Input;

// TODO: 联调时替换为接口数据
// 云主机实例清单（复用腾讯云 CVM 管理维度：机型/规格/数量）
const TIER_1 = [
    { label: '应用服务器', instanceType: '标准型S5', spec: '2C4G', disk: 200, count: 1 },
    { label: '数据库服务器', instanceType: '标准型S5', spec: '2C4G', disk: 200, count: 1 },
];
const TIER_2 = [
    { label: '应用服务器', instanceType: '标准型S5', spec: '4C8G', disk: 500, count: 2 },
    { label: '数据库服务器', instanceType: '标准型S5', spec: '4C8G', disk: 500, count: 1 },
];
const TIER_3 = [
    { label: '应用服务器', instanceType: '标准型S5', spec: '8C16G', disk: 1000, count: 4 },
    { label: '数据库服务器', instanceType: '标准型S5', spec: '8C16G', disk: 1000, count: 2 },
];
const TIER_4 = [
    { label: '应用服务器', instanceType: '标准型S5', spec: '16C32G', disk: 2000, count: 8 },
    { label: '数据库服务器', instanceType: '标准型S5', spec: '16C32G', disk: 2000, count: 3 },
];
const renderInstanceSummary = (config) => {
    if (!config?.instances?.length) return '--';
    return config.instances.map(i => `${i.count}×${i.label} ${i.spec}/${i.disk}GB`).join(' + ');
};
// 企业需付/月 = 平台成本/月 × 月租费成本比；未配商务返回 0
const calcEnterpriseMonthlyCost = (record) => {
    const ratio = record?.bizConfig?.monthlyRentRatio;
    if (ratio == null || ratio <= 0) return 0;
    return Number((record.platformCost * ratio).toFixed(2));
};
const MOCK_AUDIT_LIST = [
    { key: '1', deployNo: 'DEP-test-A01', companyName: 'test-东莞康林物联网有限公司', companyId: 'test-JGSf0Nd7',
        region: '广州', deviceCount: 5000, config: { instances: TIER_2 }, platformCost: 3200.00,
        bizConfig: { monthlyRentRatio: 1.5, elasticUsageRatio: 1.2 },
        auditStatus: 'pending', deployStatus: null, submitTime: '2026-06-20 10:30:00' },
    { key: '2', deployNo: 'DEP-test-A02', companyName: 'test-深圳智联科技有限公司', companyId: 'test-SZ888',
        region: '上海', deviceCount: 20000, config: { instances: TIER_3 }, platformCost: 6800.00,
        bizConfig: { monthlyRentRatio: null, elasticUsageRatio: null },
        auditStatus: 'pending', deployStatus: null, submitTime: '2026-06-22 09:00:00' },
    { key: '3', deployNo: 'DEP-test-A03', companyName: 'test-北京云联科技', companyId: 'test-BJ666',
        region: '北京', deviceCount: 80000, config: { instances: TIER_4 }, platformCost: 15000.00,
        bizConfig: { monthlyRentRatio: 1.6, elasticUsageRatio: 1.3 },
        auditStatus: 'approved', deployStatus: 'deploying', submitTime: '2026-06-19 14:00:00' },
    { key: '4', deployNo: 'DEP-test-A04', companyName: 'test-杭州数智网络', companyId: 'test-HZ999',
        region: '南京', deviceCount: 3000, config: { instances: TIER_2 }, platformCost: 3200.00,
        bizConfig: { monthlyRentRatio: 1.4, elasticUsageRatio: 1.2 },
        auditStatus: 'approved', deployStatus: 'completed', submitTime: '2026-04-18 11:00:00', completeTime: '2026-04-18 14:30:00', deployTime: '2026-04-18 12:00:00',
        customDomain: 'https://iot.hz-network.com', domainStatus: 'resolved' },
    { key: '5', deployNo: 'DEP-test-A05', companyName: 'test-成都智眼科技', companyId: 'test-CD555',
        region: '成都', deviceCount: 1000, config: { instances: TIER_1 }, platformCost: 1200.00,
        bizConfig: { monthlyRentRatio: null, elasticUsageRatio: null },
        auditStatus: 'rejected', deployStatus: null, submitTime: '2026-06-21 08:00:00', rejectReason: '资料不完整', rejectTime: '2026-06-21 10:00:00' },
    { key: '6', deployNo: 'DEP-test-A06', companyName: 'test-上海智科信息', companyId: 'test-SH777',
        region: '上海', deviceCount: 15000, config: { instances: TIER_3 }, platformCost: 6800.00,
        bizConfig: { monthlyRentRatio: 1.5, elasticUsageRatio: 1.2 },
        auditStatus: 'approved', deployStatus: 'failed', submitTime: '2026-06-20 15:00:00', failReason: '服务器开通超时' },
    { key: '7', deployNo: 'DEP-test-A07', companyName: 'test-武汉光谷科技', companyId: 'test-WH222',
        region: '北京', deviceCount: 35000, config: { instances: TIER_3 }, platformCost: 6500.00,
        bizConfig: { monthlyRentRatio: 1.5, elasticUsageRatio: 1.2 },
        auditStatus: 'approved', deployStatus: null, submitTime: '2026-06-23 09:00:00' },
    { key: '8', deployNo: 'DEP-test-A08', companyName: 'test-深圳云端科技', companyId: 'test-SZ666',
        region: '广州', deviceCount: 5000, config: { instances: TIER_4 }, platformCost: 15000.00,
        bizConfig: { monthlyRentRatio: 1.6, elasticUsageRatio: 1.3 },
        auditStatus: 'approved', deployStatus: 'upgrading', submitTime: '2026-07-15 10:00:00', completeTime: '2026-03-16 11:30:00', deployTime: '2026-03-16 09:00:00',
        customDomain: 'https://iot.sz-cloud.com', domainStatus: 'resolved' },
];

const AUDIT_STATUS = {
    pending: { text: '待审核', color: 'blue' },
    approved: { text: '已通过', color: 'green' },
    rejected: { text: '已驳回', color: 'red' },
};
const DEPLOY_STATUS = {
    deploying: { text: '部署中', color: 'processing' },
    upgrading: { text: '升级中', color: 'processing' },
    completed: { text: '已完成', color: 'green' },
    failed: { text: '部署失败', color: 'red' },
};
// 自定义域名 DNS 解析状态（与 PrivateDeploy.js 一致）
const DNS_STATUS = {
    checking: { text: '解析中', color: 'processing' },
    resolved: { text: '已生效', color: 'green' },
    failed: { text: '解析失败', color: 'red' },
};

// 服务器配置匹配（与 PrivateDeploy.js 共用逻辑，联调时替换为接口）
const MOCK_REGIONS = [
    { label: '广州', value: 'ap-guangzhou' },{ label: '上海', value: 'ap-shanghai' },{ label: '北京', value: 'ap-beijing' },
    { label: '南京', value: 'ap-nanjing' },{ label: '成都', value: 'ap-chengdu' },{ label: '重庆', value: 'ap-chongqing' },
    { label: '香港', value: 'ap-hongkong' },{ label: '新加坡', value: 'ap-singapore' },
];
const MOCK_SERVER_CONFIG = [
    { region: 'ap-guangzhou', minDevices: 1, maxDevices: 3000, instances: TIER_1, monthlyFee: 1200 },
    { region: 'ap-guangzhou', minDevices: 3001, maxDevices: 10000, instances: TIER_2, monthlyFee: 3200 },
    { region: 'ap-guangzhou', minDevices: 10001, maxDevices: 50000, instances: TIER_3, monthlyFee: 6500 },
    { region: 'ap-guangzhou', minDevices: 50001, maxDevices: 100000, instances: TIER_4, monthlyFee: 15000 },
    { region: 'ap-shanghai', minDevices: 1, maxDevices: 3000, instances: TIER_1, monthlyFee: 1300 },
    { region: 'ap-shanghai', minDevices: 3001, maxDevices: 10000, instances: TIER_2, monthlyFee: 3400 },
    { region: 'ap-shanghai', minDevices: 10001, maxDevices: 50000, instances: TIER_3, monthlyFee: 6800 },
    { region: 'ap-shanghai', minDevices: 50001, maxDevices: 100000, instances: TIER_4, monthlyFee: 16000 },
    { region: 'ap-beijing', minDevices: 1, maxDevices: 3000, instances: TIER_1, monthlyFee: 1200 },
    { region: 'ap-beijing', minDevices: 3001, maxDevices: 10000, instances: TIER_2, monthlyFee: 3200 },
    { region: 'ap-beijing', minDevices: 10001, maxDevices: 50000, instances: TIER_3, monthlyFee: 6500 },
    { region: 'ap-beijing', minDevices: 50001, maxDevices: 100000, instances: TIER_4, monthlyFee: 15000 },
    { region: 'ap-nanjing', minDevices: 1, maxDevices: 3000, instances: TIER_1, monthlyFee: 1250 },
    { region: 'ap-nanjing', minDevices: 3001, maxDevices: 10000, instances: TIER_2, monthlyFee: 3300 },
    { region: 'ap-nanjing', minDevices: 10001, maxDevices: 50000, instances: TIER_3, monthlyFee: 6600 },
    { region: 'ap-nanjing', minDevices: 50001, maxDevices: 100000, instances: TIER_4, monthlyFee: 15500 },
    { region: 'ap-chengdu', minDevices: 1, maxDevices: 3000, instances: TIER_1, monthlyFee: 1200 },
    { region: 'ap-chengdu', minDevices: 3001, maxDevices: 10000, instances: TIER_2, monthlyFee: 3200 },
    { region: 'ap-chengdu', minDevices: 10001, maxDevices: 50000, instances: TIER_3, monthlyFee: 6500 },
    { region: 'ap-chengdu', minDevices: 50001, maxDevices: 100000, instances: TIER_4, monthlyFee: 15000 },
];
const matchConfig = (region, deviceCount) => {
    const candidates = MOCK_SERVER_CONFIG.filter(c => c.region === region);
    return candidates.find(c => deviceCount >= c.minDevices && deviceCount <= c.maxDevices) || null;
};

const formatDeviceCount = (n) => {
    if (!n && n !== 0) return '--';
    if (n >= 10000 && n % 10000 === 0) return `${n / 10000}w`;
    if (n >= 10000) return `${(n / 10000).toFixed(1)}w`;
    return n?.toLocaleString();
};

// 审核和部署独立筛选
const FILTER_AUDIT = [
    { label: '待审核', value: 'pending' },
    { label: '已通过', value: 'approved' },
    { label: '已驳回', value: 'rejected' },
];
const FILTER_DEPLOY = [
    { label: '部署中', value: 'deploying' },
    { label: '已完成', value: 'completed' },
    { label: '升级中', value: 'upgrading' },
    { label: '部署失败', value: 'failed' },
];

const PrivateDeployAudit = () => {
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({ auditStatus: [], deployStatus: [], dateRange: [] });
    const [auditModal, setAuditModal] = useState({ open: false, record: null, action: null });
    const [rejectReason, setRejectReason] = useState('');
    const [editRegion, setEditRegion] = useState(null);
    const [editDevices, setEditDevices] = useState(null);
    const [editUnit, setEditUnit] = useState(10000);   // 审核时设备数单位（万）
    const [editConfig, setEditConfig] = useState(null);

    // 审核时实际设备数 = 输入值 × 单位
    const actualEditDevices = editDevices ? editDevices * editUnit : null;
    const [progressDrawer, setProgressDrawer] = useState({ open: false, record: null });

    // 升配相关状态
    const [upgradeModal, setUpgradeModal] = useState({ open: false, record: null });
    const [upgradeDevices, setUpgradeDevices] = useState(null);
    const [upgradeUnit, setUpgradeUnit] = useState(10000);
    const [upgradeRegionId, setUpgradeRegionId] = useState(null);
    const [upgradeConfig, setUpgradeConfig] = useState(null);
    const [upgradeProgressDrawer, setUpgradeProgressDrawer] = useState({ open: false, record: null });
    const [upgradeFailed, setUpgradeFailed] = useState(false); // mock 升配失败模拟

    useEffect(() => { fetchRecords(); }, []); // eslint-disable-line

    const fetchRecords = () => {
        setLoading(true);
        setTimeout(() => { setRecords(MOCK_AUDIT_LIST); setLoading(false); }, 400);
    };

    const handleSearch = () => {
        setLoading(true);
        setTimeout(() => {
            let data = [...MOCK_AUDIT_LIST];
            if (filters.auditStatus?.length > 0) {
                data = data.filter(r => filters.auditStatus.includes(r.auditStatus));
            }
            if (filters.deployStatus?.length > 0) {
                data = data.filter(r => r.deployStatus && filters.deployStatus.includes(r.deployStatus));
            }
            setRecords(data);
            setLoading(false);
        }, 200);
    };

    const handleReset = () => { setFilters({ auditStatus: [], deployStatus: [], dateRange: [] }); fetchRecords(); };

    const handleRedeploy = (record) => {
        Modal.confirm({
            title: '重新部署',
            content: `确认对「${record.companyName}」重新执行部署？`,
            okText: '确认',
            onOk: () => {
                setRecords(prev => prev.map(r => r.key === record.key ? { ...r, deployStatus: 'deploying', failReason: undefined } : r));
                message.success('已重新开始部署');
            },
        });
    };

    const handleDeploy = (record) => {
        Modal.confirm({
            title: '部署服务',
            content: `确认对「${record.companyName}」开始部署？将自动创建 SaaS、开通服务器并部署服务。`,
            okText: '确认部署',
            onOk: () => {
                setRecords(prev => prev.map(r => r.key === record.key ? { ...r, deployStatus: 'deploying', deployTime: new Date().toLocaleString('zh-CN', { hour12: false }) } : r));
                message.success('部署已开始');
            },
        });
    };
    const handleAuditOpen = (record) => {
        setAuditModal({ open: true, record, action: 'choose' });
        setRejectReason('');
        const defaultRegion = MOCK_REGIONS.find(r => r.label === record.region)?.value || null;
        setEditRegion(defaultRegion);
        setEditUnit(10000);
        // deviceCount 存储的是实际设备数，除以单位得输入值
        setEditDevices(record.deviceCount ? record.deviceCount / 10000 : null);
        setEditConfig(matchConfig(defaultRegion, record.deviceCount));
    };

    const handleAuditApprove = () => {
        const { record } = auditModal;
        const regionLabel = MOCK_REGIONS.find(r => r.value === editRegion)?.label || record.region;
        const newDevices = actualEditDevices || record.deviceCount;
        const newConfig = editConfig || record.config;
        const newPlatformCost = editConfig ? editConfig.monthlyFee : record.platformCost;
        const enterpriseCost = calcEnterpriseMonthlyCost({ platformCost: newPlatformCost, bizConfig: record.bizConfig });
        setRecords(prev => prev.map(r => r.key === record.key ? {
            ...r,
            auditStatus: 'approved',
            region: regionLabel,
            deviceCount: newDevices,
            config: { instances: newConfig.instances },
            platformCost: newPlatformCost,
            enterpriseCost,
        } : r));
        message.success('审核通过，请点击「部署服务」开始部署');
        setAuditModal({ open: false, record: null, action: null });
        setEditRegion(null);
        setEditDevices(null);
        setEditConfig(null);
    };

    const handleAuditReject = () => {
        if (!rejectReason.trim()) { message.warning('请填写驳回原因'); return; }
        const { record } = auditModal;
        setRecords(prev => prev.map(r =>
            r.key === record.key
                ? { ...r, auditStatus: 'rejected', deployStatus: null, rejectReason, rejectTime: new Date().toLocaleString('zh-CN', { hour12: false }) }
                : r));
        message.success('已驳回');
        setAuditModal({ open: false, record: null, action: null });
        setRejectReason('');
    };

    // ── 升配处理 ──
    const upgradeActualDevices = upgradeDevices ? upgradeDevices * upgradeUnit : null;

    const handleUpgradeOpen = (record) => {
        const rid = MOCK_REGIONS.find(r => r.label === record.region)?.value || null;
        setUpgradeModal({ open: true, record });
        setUpgradeUnit(10000);
        setUpgradeRegionId(rid);
        setUpgradeDevices(null);
        setUpgradeConfig(null);
    };

    const handleUpgradeConfirm = () => {
        const { record } = upgradeModal;
        const newDevices = upgradeActualDevices;
        const newConfig = upgradeConfig;
        const newPlatformCost = newConfig ? newConfig.monthlyFee : record.platformCost;
        Modal.confirm({
            title: '确认升配',
            content: '确认发起升配？升级当月将按新旧配置的实际生效天数比例拆分计费。',
            okText: '确认升配',
            onOk: () => {
                setRecords(prev => prev.map(r => r.key === record.key ? {
                    ...r,
                    deployStatus: 'upgrading',
                    // 暂存新配置，升级完成后生效
                    newDeviceCount: newDevices,
                    newConfig: newConfig ? { instances: newConfig.instances } : record.config,
                    newPlatformCost: newPlatformCost,
                    newEnterpriseCost: calcEnterpriseMonthlyCost({ platformCost: newPlatformCost, bizConfig: record.bizConfig }),
                } : r));
                message.success('升配已发起，正在处理中');
                setUpgradeModal({ open: false, record: null });
            },
        });
    };

    const upgradeHasBiz = upgradeModal.record?.bizConfig?.monthlyRentRatio != null && upgradeModal.record?.bizConfig?.monthlyRentRatio > 0;
    const upgradeConfirmDisabled = !upgradeDevices || !upgradeActualDevices || upgradeActualDevices < 1 || upgradeActualDevices > 100000 || !upgradeConfig || !upgradeHasBiz;

    // 通过按钮禁用：未配置私有化部署商务 或 参数无效
    const auditBizConfigured = auditModal.record?.bizConfig?.monthlyRentRatio != null && auditModal.record?.bizConfig?.monthlyRentRatio > 0;
    const approveDisabled = !editRegion || !actualEditDevices || actualEditDevices < 1 || actualEditDevices > 100000 || !editConfig || !auditBizConfigured;

    const columns = [
        { title: '申请企业', key: 'company', width: 200,
            render: (_, r) => <div><Text strong style={{ fontSize: 13 }}>{r.companyName}</Text><br /><Text type="secondary" style={{ fontSize: 11 }}>{r.companyId}</Text></div> },
        { title: '服务区域', dataIndex: 'region', width: 100 },
        { title: '最大设备数', dataIndex: 'deviceCount', width: 110, render: (v) => formatDeviceCount(v) },
        { title: '匹配配置', key: 'config', width: 200,
            render: (_, r) => <Text style={{ fontSize: 12 }}>{renderInstanceSummary(r.config)}</Text> },
        { title: '平台成本/月', key: 'platformCost', width: 130,
            render: (_, r) => r.platformCost == null
                ? <span style={{ color: '#ccc' }}>--</span>
                : <Text>¥ {r.platformCost.toLocaleString(undefined, { minimumFractionDigits: 2 })}</Text> },
        { title: '企业需付/月', key: 'enterpriseCost', width: 140,
            render: (_, r) => {
                const cost = calcEnterpriseMonthlyCost(r);
                if (r.bizConfig?.monthlyRentRatio == null || r.bizConfig?.monthlyRentRatio <= 0) {
                    return <span><Text type="danger">¥ 0.00</Text> <Tag color="red" style={{ border: 'none', fontSize: 11 }}>未配商务</Tag></span>;
                }
                return <Text>¥ {cost.toLocaleString(undefined, { minimumFractionDigits: 2 })}</Text>;
            } },
        { title: '审核状态', dataIndex: 'auditStatus', width: 90,
            render: (v) => { const s = AUDIT_STATUS[v] || { text: v, color: 'default' }; return <Tag color={s.color} style={{ border: 'none' }}>{s.text}</Tag>; } },
        { title: '部署状态', dataIndex: 'deployStatus', width: 90,
            render: (v) => {
                if (!v) return <Text type="secondary" style={{ fontSize: 12 }}>--</Text>;
                const s = DEPLOY_STATUS[v] || { text: v, color: 'default' };
                return <Tag color={s.color} style={{ border: 'none' }}>{s.text}</Tag>;
            } },
        { title: '自定义域名', key: 'customDomain', width: 140,
            render: (_, r) => {
                if (!r.customDomain) return <Text type="secondary">-</Text>;
                const st = DNS_STATUS[r.domainStatus] || { text: r.domainStatus || '已生效', color: 'green' };
                return (
                    <div>
                        <Text style={{ fontFamily: 'monospace', fontSize: 12 }}>{r.customDomain}</Text>
                        <br />
                        <Tag color={st.color} style={{ border: 'none', fontSize: 11, marginTop: 4 }}>{st.text}</Tag>
                    </div>
                );
            } },
        { title: '提交时间', dataIndex: 'submitTime', width: 160 },
        { title: '操作', key: 'action', width: 200, fixed: 'right',
            render: (_, r) => {
                if (r.auditStatus === 'pending') return (
                    <Button type="link" size="small" onClick={() => handleAuditOpen(r)}>审核</Button>
                );
                if (r.auditStatus === 'approved' && !r.deployStatus) return (
                    <Button type="link" size="small" icon={<CloudUploadOutlined />} onClick={() => handleDeploy(r)}>部署服务</Button>
                );
                if (r.auditStatus === 'approved' && r.deployStatus === 'deploying') return (
                    <Button type="link" size="small" onClick={() => setProgressDrawer({ open: true, record: r })}>查看进度</Button>
                );
                if (r.auditStatus === 'approved' && r.deployStatus === 'failed') return (
                    <Button type="link" size="small" icon={<RedoOutlined />} onClick={() => handleRedeploy(r)}>重新部署</Button>
                );
                if (r.auditStatus === 'approved' && r.deployStatus === 'completed') return (
                    <Button type="link" size="small" onClick={() => handleUpgradeOpen(r)}>升配</Button>
                );
                if (r.auditStatus === 'approved' && r.deployStatus === 'upgrading') return (
                    <Button type="link" size="small" onClick={() => setUpgradeProgressDrawer({ open: true, record: r })}>查看升级进度</Button>
                );
                return <Text type="secondary" style={{ fontSize: 12 }}>--</Text>;
            } },
    ];

    return (
        <div style={{ padding: 24 }}>
            <div style={{ marginBottom: 16 }}><Title level={4} style={{ margin: 0 }}>私有部署管理</Title></div>
            <Card bordered={false} style={{ marginBottom: 8, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
                <Form layout="inline">
                    <Form.Item label="审核状态" style={{ marginBottom: 0 }}>
                        <Select mode="multiple" allowClear placeholder="全部" style={{ width: 200 }}
                            value={filters.auditStatus} onChange={(v) => setFilters(prev => ({ ...prev, auditStatus: v }))}
                            options={FILTER_AUDIT} />
                    </Form.Item>
                    <Form.Item label="部署状态" style={{ marginBottom: 0 }}>
                        <Select mode="multiple" allowClear placeholder="全部" style={{ width: 200 }}
                            value={filters.deployStatus} onChange={(v) => setFilters(prev => ({ ...prev, deployStatus: v }))}
                            options={FILTER_DEPLOY} />
                    </Form.Item>
                    <Form.Item label="提交时间" style={{ marginBottom: 0 }}>
                        <RangePicker onChange={(dates) => setFilters(prev => ({ ...prev, dateRange: dates || [] }))} />
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 0 }}>
                        <Space><Button type="primary" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button><Button icon={<ReloadOutlined />} onClick={handleReset}>重置</Button></Space>
                    </Form.Item>
                </Form>
            </Card>
            <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
                <Table columns={columns} dataSource={records} loading={loading} rowKey="key"
                    pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }}
                    scroll={{ x: 1890 }} />
            </Card>
            <Modal title="审核申请" open={auditModal.open} width={560}
                onCancel={() => { setAuditModal({ open: false, record: null, action: null }); }}
                footer={auditModal.action === 'reject' ? [
                    <Button key="cancel" onClick={() => setAuditModal(prev => ({ ...prev, action: 'choose' }))}>返回</Button>,
                    <Button key="confirm" danger type="primary" onClick={handleAuditReject}>确认驳回</Button>,
                ] : [
                    <Button key="cancel" onClick={() => { setAuditModal({ open: false, record: null, action: null }); }}>取消</Button>,
                    <Button key="reject" danger onClick={() => setAuditModal(prev => ({ ...prev, action: 'reject' }))}>驳回</Button>,
                    <Tooltip title={!auditBizConfigured ? '需先配置企业私有化部署商务' : ''}>
                        <Button key="approve" type="primary" onClick={handleAuditApprove}
                            disabled={approveDisabled}>通过</Button>
                    </Tooltip>,
                ]}>
                <Descriptions column={1} size="small" bordered style={{ marginBottom: 16 }}>
                    <Descriptions.Item label="申请企业">{auditModal.record?.companyName}</Descriptions.Item>
                    <Descriptions.Item label="企业 ID">{auditModal.record?.companyId}</Descriptions.Item>
                </Descriptions>

                <div style={{ marginBottom: 16 }}>
                    <Text strong style={{ display: 'block', marginBottom: 8 }}>服务区域 <Text type="danger">*</Text></Text>
                    <Select
                        style={{ width: '100%' }}
                        value={editRegion}
                        status={!editRegion ? 'error' : undefined}
                        onChange={(v) => {
                            setEditRegion(v);
                            setEditConfig(actualEditDevices ? matchConfig(v, actualEditDevices) : null);
                        }}
                        showSearch optionFilterProp="label"
                        options={MOCK_REGIONS}
                    />
                </div>

                <div style={{ marginBottom: 16 }}>
                    <Text strong style={{ display: 'block', marginBottom: 8 }}>最大设备数 <Text type="danger">*</Text></Text>
                    <Space.Compact style={{ width: '100%' }}>
                        <Input
                            style={{ flex: 1 }}
                            type="number"
                            placeholder="请输入数量"
                            status={(!editDevices || editDevices < 1) ? 'error' : undefined}
                            value={editDevices ?? ''}
                            onChange={(e) => {
                                const v = parseInt(e.target.value, 10);
                                const val = isNaN(v) ? null : v;
                                setEditDevices(val);
                                setEditConfig(val && editRegion ? matchConfig(editRegion, val * editUnit) : null);
                            }}
                            min={0} step={1}
                        />
                        <Select value={editUnit} onChange={(v) => {
                            setEditUnit(v);
                            setEditConfig(editDevices && editRegion ? matchConfig(editRegion, editDevices * v) : null);
                        }} style={{ width: 90 }}
                            options={[{ label: '万 (w)', value: 10000 }]} />
                    </Space.Compact>
                    {actualEditDevices > 0 && <Text type="secondary" style={{ fontSize: 12 }}>实际：{actualEditDevices.toLocaleString()}（{formatDeviceCount(actualEditDevices)}）</Text>}
                </div>

                {editConfig ? (
                    <div style={{ padding: 16, background: '#f6ffed', borderRadius: 8, marginBottom: 16 }}>
                        <Text strong style={{ display: 'block', marginBottom: 12 }}>配置预览</Text>
                        <Table size="small" pagination={false} bordered dataSource={editConfig.instances} rowKey={(i) => i.label}
                            style={{ marginBottom: 12 }}
                            columns={[
                                { title: '云主机', dataIndex: 'label' },
                                { title: '数量', dataIndex: 'count', width: 70, render: (v) => `${v} 台` },
                                { title: '机型', dataIndex: 'instanceType', width: 110 },
                                { title: '规格', dataIndex: 'spec', width: 90 },
                                { title: '磁盘', dataIndex: 'disk', width: 90, render: (v) => `${v}GB` },
                            ]} />
                        <Divider style={{ margin: '8px 0' }} />
                        <Row justify="space-between" style={{ marginBottom: 12 }}>
                            <Text strong>平台成本（运维推送）</Text>
                            <Text strong style={{ fontSize: 16, color: '#1890ff' }}>¥ {editConfig.monthlyFee.toLocaleString(undefined, { minimumFractionDigits: 2 })} / 月</Text>
                        </Row>
                        <Row justify="space-between" align="middle">
                            <Text strong>企业需付/月</Text>
                            {auditBizConfigured ? (
                                <Text strong style={{ fontSize: 16, color: '#1890ff' }}>¥ {calcEnterpriseMonthlyCost({ platformCost: editConfig.monthlyFee, bizConfig: auditModal.record?.bizConfig }).toLocaleString(undefined, { minimumFractionDigits: 2 })} / 月</Text>
                            ) : (
                                <span>
                                    <Text strong type="danger" style={{ fontSize: 16 }}>¥ 0.00 / 月（平台成本 × 0）</Text>
                                    <Tag color="red" style={{ marginLeft: 8, border: 'none' }}>需配置企业私有化部署商务</Tag>
                                </span>
                            )}
                        </Row>
                    </div>
                ) : null}

                {auditModal.action === 'reject' && (
                    <div>
                        <Text type="danger" strong style={{ display: 'block', marginBottom: 8 }}>驳回原因（必填）</Text>
                        <TextArea rows={3} placeholder="请填写驳回原因" value={rejectReason}
                            onChange={(e) => setRejectReason(e.target.value)} />
                    </div>
                )}
                {auditModal.action === 'choose' && (
                    <Text type="secondary">请选择审核结果：通过自动部署，或驳回并填写原因。</Text>
                )}
            </Modal>

            <Drawer title="部署进度" open={progressDrawer.open} onClose={() => setProgressDrawer({ open: false, record: null })} width={480}>
                <div style={{ padding: '16px 20px', background: '#f6ffed', borderRadius: 8, border: '1px solid #b7eb8f', marginBottom: 20 }}>
                    <Row align="middle" style={{ marginBottom: 8 }}>
                        <Spin indicator={<LoadingOutlined style={{ fontSize: 16 }} spin />} style={{ marginRight: 8 }} />
                        <Text strong style={{ color: '#52c41a' }}>部署进行中</Text>
                        <Text type="secondary" style={{ marginLeft: 8, fontSize: 12 }}>预计耗时 5-10 分钟</Text>
                    </Row>
                </div>
                <Descriptions column={1} size="small" bordered style={{ marginBottom: 16 }}>
                    <Descriptions.Item label="申请企业">{progressDrawer.record?.companyName}</Descriptions.Item>
                    <Descriptions.Item label="部署编号">{progressDrawer.record?.deployNo}</Descriptions.Item>
                </Descriptions>
                <Steps size="small" direction="vertical" current={Math.floor(Math.random() * 3) + 1}
                    items={[
                        { title: '开通服务器', description: '正在申请云服务器资源' },
                        { title: '部署PaaS服务', description: '正在部署平台核心服务' },
                        { title: '部署SaaS服务', description: '正在部署应用服务实例' },
                        { title: '配置网络', description: '正在配置网络与安全策略' },
                    ]} />
            </Drawer>

            {/* ── 升配弹窗 ── */}
            <Modal title="升配" open={upgradeModal.open} width={640}
                onCancel={() => { setUpgradeModal({ open: false, record: null }); }}
                footer={[
                    <Button key="cancel" onClick={() => { setUpgradeModal({ open: false, record: null }); }}>取消</Button>,
                    <Tooltip title={!upgradeHasBiz ? '需先配置企业私有化部署商务' : ''}>
                        <Button key="confirm" type="primary" onClick={handleUpgradeConfirm} disabled={upgradeConfirmDisabled}>确认升配</Button>
                    </Tooltip>,
                ]}>
                <Descriptions column={1} size="small" bordered style={{ marginBottom: 16 }}>
                    <Descriptions.Item label="申请企业">{upgradeModal.record?.companyName}</Descriptions.Item>
                    <Descriptions.Item label="企业 ID">{upgradeModal.record?.companyId}</Descriptions.Item>
                </Descriptions>

                {/* 当前配置 */}
                <div style={{ padding: 12, background: '#fafafa', borderRadius: 8, marginBottom: 16 }}>
                    <Text strong style={{ display: 'block', marginBottom: 8 }}>当前配置</Text>
                    <Descriptions column={1} size="small" colon={false} labelStyle={{ color: '#8c8c8c', fontSize: 12 }}>
                        <Descriptions.Item label="设备数">{formatDeviceCount(upgradeModal.record?.deviceCount)}</Descriptions.Item>
                        <Descriptions.Item label="服务器">{renderInstanceSummary(upgradeModal.record?.config)}</Descriptions.Item>
                        <Descriptions.Item label="平台成本">¥ {upgradeModal.record?.platformCost?.toLocaleString(undefined, { minimumFractionDigits: 2 })} / 月</Descriptions.Item>
                        <Descriptions.Item label="企业需付">¥ {calcEnterpriseMonthlyCost(upgradeModal.record).toLocaleString(undefined, { minimumFractionDigits: 2 })} / 月</Descriptions.Item>
                    </Descriptions>
                </div>

                {/* 新设备数 */}
                <div style={{ marginBottom: 16 }}>
                    <Text strong style={{ display: 'block', marginBottom: 8 }}>新最大设备数 <Text type="danger">*</Text></Text>
                    <Space.Compact style={{ width: '100%' }}>
                        <Input
                            style={{ flex: 1 }}
                            type="number"
                            placeholder="请输入新设备数"
                            status={(!upgradeDevices || upgradeDevices < 1) ? 'error' : undefined}
                            value={upgradeDevices ?? ''}
                            onChange={(e) => {
                                const v = parseInt(e.target.value, 10);
                                const val = isNaN(v) ? null : v;
                                setUpgradeDevices(val);
                                setUpgradeConfig(val && upgradeRegionId ? matchConfig(upgradeRegionId, val * upgradeUnit) : null);
                            }}
                            min={0} step={1}
                        />
                        <Select value={upgradeUnit} onChange={(v) => {
                            setUpgradeUnit(v);
                            setUpgradeConfig(upgradeDevices && upgradeRegionId ? matchConfig(upgradeRegionId, upgradeDevices * v) : null);
                        }} style={{ width: 90 }}
                            options={[{ label: '万 (w)', value: 10000 }]} />
                    </Space.Compact>
                    {upgradeActualDevices > 0 && <Text type="secondary" style={{ fontSize: 12 }}>实际：{upgradeActualDevices.toLocaleString()}（{formatDeviceCount(upgradeActualDevices)}）</Text>}
                </div>

                {/* 新配置预览 */}
                {upgradeConfig ? (
                    <div style={{ padding: 16, background: '#f6ffed', borderRadius: 8, marginBottom: 16 }}>
                        <Text strong style={{ display: 'block', marginBottom: 12 }}>新配置预览</Text>
                        <Table size="small" pagination={false} bordered dataSource={upgradeConfig.instances} rowKey={(i) => i.label}
                            style={{ marginBottom: 12 }}
                            columns={[
                                { title: '云主机', dataIndex: 'label' },
                                { title: '数量', dataIndex: 'count', width: 70, render: (v) => `${v} 台` },
                                { title: '机型', dataIndex: 'instanceType', width: 110 },
                                { title: '规格', dataIndex: 'spec', width: 90 },
                                { title: '磁盘', dataIndex: 'disk', width: 90, render: (v) => `${v}GB` },
                            ]} />
                        <Divider style={{ margin: '8px 0' }} />
                        <Row justify="space-between" style={{ marginBottom: 12 }}>
                            <Text strong>新平台成本（运维推送）</Text>
                            <Text strong style={{ fontSize: 16, color: '#1890ff' }}>¥ {upgradeConfig.monthlyFee.toLocaleString(undefined, { minimumFractionDigits: 2 })} / 月</Text>
                        </Row>
                        <Row justify="space-between" align="middle">
                            <Text strong>新企业需付/月</Text>
                            {upgradeHasBiz ? (
                                <Text strong style={{ fontSize: 16, color: '#1890ff' }}>¥ {calcEnterpriseMonthlyCost({ platformCost: upgradeConfig.monthlyFee, bizConfig: upgradeModal.record?.bizConfig }).toLocaleString(undefined, { minimumFractionDigits: 2 })} / 月</Text>
                            ) : (
                                <span>
                                    <Text strong type="danger" style={{ fontSize: 16 }}>¥ 0.00 / 月（平台成本 × 0）</Text>
                                    <Tag color="red" style={{ marginLeft: 8, border: 'none' }}>需配置企业私有化部署商务</Tag>
                                </span>
                            )}
                        </Row>
                    </div>
                ) : null}

                {/* 变更对比 */}
                {upgradeConfig && (
                    <div style={{ padding: 12, background: '#fffbe6', borderRadius: 8, marginBottom: 8 }}>
                        <Text strong style={{ display: 'block', marginBottom: 8 }}>变更对比</Text>
                        <Row><Text type="secondary" style={{ width: 80 }}>设备数：</Text><Text>{formatDeviceCount(upgradeModal.record?.deviceCount)} → {formatDeviceCount(upgradeActualDevices)}（+{formatDeviceCount(upgradeActualDevices - upgradeModal.record?.deviceCount)}）</Text></Row>
                        <Row><Text type="secondary" style={{ width: 80 }}>配置：</Text><Text>{renderInstanceSummary(upgradeModal.record?.config)} → {renderInstanceSummary(upgradeConfig)}</Text></Row>
                        <Row><Text type="secondary" style={{ width: 80 }}>企业需付/月：</Text><Text>¥ {calcEnterpriseMonthlyCost(upgradeModal.record).toLocaleString(undefined, { minimumFractionDigits: 2 })} → ¥ {calcEnterpriseMonthlyCost({ platformCost: upgradeConfig.monthlyFee, bizConfig: upgradeModal.record?.bizConfig }).toLocaleString(undefined, { minimumFractionDigits: 2 })}</Text></Row>
                    </div>
                )}

                <Text type="secondary" style={{ fontSize: 12 }}>提示：升级当月将按新旧配置的实际生效天数比例拆分计费。</Text>
            </Modal>

            {/* ── 升级进度 Drawer ── */}
            <Drawer title="升级进度" open={upgradeProgressDrawer.open} onClose={() => { setUpgradeProgressDrawer({ open: false, record: null }); setUpgradeFailed(false); }} width={480}>
                <div style={{ padding: '16px 20px', background: upgradeFailed ? '#fff2f0' : '#f6ffed', borderRadius: 8, border: upgradeFailed ? '1px solid #ffccc7' : '1px solid #b7eb8f', marginBottom: 20 }}>
                    {upgradeFailed ? (
                        <>
                            <Row align="middle" style={{ marginBottom: 4 }}>
                                <Text strong style={{ color: '#ff4d4f' }}>升级失败</Text>
                            </Row>
                            <Text type="secondary" style={{ fontSize: 12 }}>服务器资源调整异常，配置已自动回滚</Text>
                        </>
                    ) : (
                        <>
                            <Row align="middle" style={{ marginBottom: 8 }}>
                                <Spin indicator={<LoadingOutlined style={{ fontSize: 16 }} spin />} style={{ marginRight: 8 }} />
                                <Text strong style={{ color: '#52c41a' }}>升级进行中</Text>
                                <Text type="secondary" style={{ marginLeft: 8, fontSize: 12 }}>服务正常运行</Text>
                            </Row>
                            <Text type="secondary" style={{ fontSize: 12 }}>升级期间新旧配置按实际生效天数分别计费</Text>
                        </>
                    )}
                </div>
                <Descriptions column={1} size="small" bordered style={{ marginBottom: 16 }}>
                    <Descriptions.Item label="申请企业">{upgradeProgressDrawer.record?.companyName}</Descriptions.Item>
                    <Descriptions.Item label="部署编号">{upgradeProgressDrawer.record?.deployNo}</Descriptions.Item>
                </Descriptions>
                {!upgradeFailed && (
                    <Steps size="small" direction="vertical" current={Math.floor(Math.random() * 3) + 1}
                        items={[
                            { title: '验证配置', description: '校验新配置参数与服务器资源' },
                            { title: '调整服务器资源', description: '扩容/调整云服务器规格' },
                            { title: '更新SaaS配置', description: '更新应用服务参数' },
                            { title: '同步账单', description: '按实际天数比例生成当月账单' },
                        ]} />
                )}
                {upgradeFailed && (
                    <Space direction="vertical" style={{ width: '100%', marginTop: 8 }}>
                        <Button type="primary" block onClick={() => {
                            setUpgradeProgressDrawer({ open: false, record: null });
                            setUpgradeFailed(false);
                            setTimeout(() => handleUpgradeOpen(upgradeProgressDrawer.record), 200);
                        }}>重新升配</Button>
                    </Space>
                )}
                <Divider />
                <Space>
                    <Button size="small" type={upgradeFailed ? 'default' : 'dashed'} danger={!upgradeFailed}
                        onClick={() => setUpgradeFailed(!upgradeFailed)}>
                        {upgradeFailed ? '模拟恢复中' : '模拟升配失败'}
                    </Button>
                    <Text type="secondary" style={{ fontSize: 11 }}>演示用</Text>
                </Space>
            </Drawer>

        </div>
    );
};

export default PrivateDeployAudit;
